import React, { Component } from 'react';
import { matchPath } from 'react-router';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as PrizesActions } from 'store/ducks/prizes';

import { Page, Breadcrumbs } from 'components';
import { Form } from 'pages/Points/Prize/components';

class Edit extends Component {
  state = {
    data: {
      goal: '',
      reward: '',
      active: true,
    },

    breadcrumbs: [
      { name: 'Home', to: '/' },
      { name: 'Pontos', to: '/points' },
      { name: 'Premiações', to: '/points/prizes' },
      { name: 'Detalhes', to: '' },
    ],
  };

  componentDidMount() {
    this.props.getPrizeRequest(this.handleGetId());
  }

  componentDidUpdate(oldProps) {
    const { prize } = this.props;

    if (oldProps.prize.loading && !prize.loading) {
      this.setState({
        data: {
          goal: prize.data.attributes.goal,
          reward: prize.data.attributes.reward,
          active: prize.data.attributes.active,
        },
      });
    }
  }

  handleGetId = () => {
    const match = matchPath(this.props.location.pathname, { path: '/points/prizes/:id/edit' });
    const { id } = match.params;

    return id;
  };

  handleChange = data => {
    this.setState({ form: data });
  };

  handleSubmit = e => {
    e.preventDefault();

    const { form } = this.state;

    this.props.updatePrizeRequest(this.handleGetId(), form);
  };

  render() {
    const { data, breadcrumbs } = this.state;
    const { update } = this.props;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Form data={data} saving={update.loading} onChange={this.handleChange} onSubmit={this.handleSubmit} />
      </Page>
    );
  }
}

const mapState = state => ({
  prize: state.prizes.detail,
  update: state.prizes.update,
});

const mapActions = dispatch => bindActionCreators(PrizesActions, dispatch);

export default connect(
  mapState,
  mapActions,
)(Edit);
